import styled from 'styled-components';
import { Utils } from 'billon-ui';

const { Text } = Utils;

export const ValidSinceValidUntil = styled(Text)`
  margin-top: -1.25rem;
  color: ${({ theme }) => theme.linkHoverColor};
`;
